import { defineStore } from 'pinia'
import { Event, postEvent } from './api'
import Cookies from 'js-cookie'
import { getPlatformName } from './usePlatformSettings'

const useEventStore = defineStore('event', () => {
    const trackEvent = async (event: Partial<Event>) => {
        await postEvent({
            ...event,
            trackable_type: Cookies.get('conda_user_profile') as 'personal' | 'company',
            platform_name: getPlatformName(),
        })
    }

    return {
        trackEvent,
    }
})

export default useEventStore
